/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const e={namespace:void 0,performanceLogger:()=>{},eventHandlerInterceptor:void 0,styleApplyer:(e,t,r)=>{t.startsWith("-")?e.style.setProperty(t,r):e.style[t]=r}},t=t=>({...e,...t});export{t as applyDefaultProjectionOptions};
